import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './BuildingDesignSupplementalComponent.metadata.json5';

import styles from '../ArchitectEngineer.module.scss';
import BuildingDesignFeesRevenuesComponent from '../subcomponents/BuildingDesignFeesRevenues/BuildingDesignFeesRevenuesComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BuildingDesignSupplementalComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BuildingDesignSupplementalComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getTotStaAToF11 =() => {
        let sum = 0

        if(!_.isUndefined(modelVM.value.atotPro5)) {
            sum += modelVM.value.atotPro5
        }

        if(!_.isUndefined(modelVM.value.barc6)) {
            sum += modelVM.value.barc6
        }

        if(!_.isUndefined(modelVM.value.ceng7)) {
            sum += modelVM.value.ceng7
        }

        if(!_.isUndefined(modelVM.value.dconPer8)) {
            sum += modelVM.value.dconPer8
        }

        if(!_.isUndefined(modelVM.value.eothPerSpe9)) {
            sum += modelVM.value.eothPerSpe9
        }

        if(!_.isUndefined(modelVM.value.fothProSpe10)) {
            sum += modelVM.value.fothProSpe10
        }
        
        return sum
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesPleProFulDet14: {
            visible: !_.isUndefined(modelVM.value.doeYouFirHavAnyFinInt13) && modelVM.value.doeYouFirHavAnyFinInt13
        },
        ifNoPleExp16: {
            visible: !_.isUndefined(modelVM.value.ifYouSubAnyDesSerDo15) && !modelVM.value.ifYouSubAnyDesSerDo15
        },
        buildingDesignFeesRevenuesComponent: {
            data: modelVM.buildingDesignFeesRevenuesDTO,
            updateWizardData,
            submissionVM,
            BuildingDesignFeesRevenuesPath: `${pathUpdated}.buildingDesignFeesRevenuesDTO`
        },
        totStaAToF11: {
            value: getTotStaAToF11(),
            readOnly: true
        },
        sta2: {
            visible: false
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            buildingDesignFeesRevenuesComponent: BuildingDesignFeesRevenuesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (changedPath === 'witResToConWitNoDes18') {
                if (!_.isUndefined(value) && (value === '-' || value < 0)) return;
            }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BuildingDesignSupplementalComponent.propTypes = wizardProps;
export default withRouter(BuildingDesignSupplementalComponent);
